import { usePreferences } from 'pe-core-frontend';
import { useMemo } from 'react';
import { useAuth } from './useAuth';
/**
 * Hook to provide user data formatted for Sierra chat integration
 *
 * Maps current user data to the format required by Sierra's secrets
 */
export const useSierraUserData = () => {
    const { currentUser } = useAuth();
    const { find: findPreference } = usePreferences();
    const userLocale = findPreference('locale')?.value || 'en_US';
    return useMemo(() => {
        if (!currentUser || !currentUser.employeeId) {
            return undefined;
        }
        // Sierra requires a Guild UUID for employeeId; if not available, return undefined
        if (!currentUser.guildUserUuid) {
            return undefined;
        }
        // Map user data to Sierra format
        return {
            email: currentUser.email || '',
            employeeId: currentUser.guildUserUuid,
            firstName: currentUser.firstName || '',
            lastName: currentUser.lastName || '',
            employerId: currentUser.clientInfo?.guildEmployerUuid || '',
            employerName: currentUser.clientInfo?.name || '',
            countryCode: currentUser.clientInfo?.country || '',
            preferredLanguage: userLocale.split('_')[0] || 'en',
            locale: userLocale || 'en_US',
        };
    }, [currentUser, userLocale]);
};
